module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO38FelicitacionesSuPresupuesto.6fca0cf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO38FelicitacionesSuPresupuesto.mp4
// module id = 764
// module chunks = 1